export default __webpack_public_path__ + "static/media/sd-event-3.4253079f.jpg";